import { FormControl, Input, Select } from '@chakra-ui/react';
import {
  WarningComponent,
  WarningProps,
} from '@texas/components/shared/WarningComponent';
import { TexasFormLabel } from '@texas/components/shared/form/TexasFormLabel';
import { articleWorkspaceStyles } from '@texas/resources/theme/styles/entityWorkspace';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface NumberProps {
  warning?: WarningProps;
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  variant?: string;
}

export function ArticleNumberInput({
  label,
  warning = {},
  value,
  onChange,
  min = 0,
  max,
  variant,
}: NumberProps) {
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <FormControl
      sx={articleWorkspaceStyles.numberField}
      id={warning.targetId}
      isInvalid={!!warning.warning}
    >
      <WarningComponent {...warning}>
        <TexasFormLabel>{label}</TexasFormLabel>
      </WarningComponent>
      <Input
        type="number"
        min={min}
        max={max}
        value={draft ?? value}
        variant={variant}
        onChange={(event) => {
          setDraft(event.target.value);
          onChange(Number(event.target.value));
        }}
        onBlur={() => setDraft(null)}
      />
    </FormControl>
  );
}

interface PositionProps {
  label: string;
  value: 'before' | 'after';
  onChange: (value: 'before' | 'after') => void;
  variant?: string;
}

export function ArticleNumberPosition({
  label,
  value,
  onChange,
  variant,
}: PositionProps) {
  const { t } = useTranslation();
  return (
    <FormControl sx={articleWorkspaceStyles.numberField}>
      <TexasFormLabel>{label}</TexasFormLabel>
      <Select
        variant={variant}
        value={value}
        onChange={(event) => onChange(event.target.value as 'before' | 'after')}
      >
        <option value="after">{t('article.copy.after')}</option>
        <option value="before">{t('article.copy.before')}</option>
      </Select>
    </FormControl>
  );
}
